import { CREATOR_FILTER_DATE_RANGE } from '@/entities/discovery';

import { getPlatformName, SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';
import type { FilterConditions } from '@/entities/discovery';
import {
  DATE_RANGE_CONFIG,
  parseDateRangeToEnum,
} from '@/entities/discovery/utils/creator-date-range-parser';

export function getPlatformLabel(filters: FilterConditions) {
  const platform = filters.platform?.[0];
  return platform ? getPlatformName(platform) : 'Platform';
}

export function getTimeRangeLabel(filters: FilterConditions) {
  const dateRange = parseDateRangeToEnum(
    {
      start_date: filters.start_date,
      end_date: filters.end_date,
    },
    CREATOR_FILTER_DATE_RANGE.LAST_60_DAYS,
  );

  return DATE_RANGE_CONFIG.get(dateRange)?.label ?? 'Time range';
}

export const getPlatformUrl = (platform: SOURCE_PLATFORM_TYPE, username: string) => {
  const urlEncodedName = encodeURI(username);
  switch (platform) {
    case SOURCE_PLATFORM_TYPE.TIKTOK:
      return `https://www.tiktok.com/@${urlEncodedName}`;
    case SOURCE_PLATFORM_TYPE.INSTAGRAM:
      return `https://www.instagram.com/${urlEncodedName}`;
    case SOURCE_PLATFORM_TYPE.YOUTUBE:
      return `https://www.youtube.com/@${urlEncodedName}`;
    default:
      return '#';
  }
};
